import { Box, Grid, Typography, useTheme } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-premium";
import { DataGrid } from "components/DataGrid";
import { CopyableCellValue } from "components/Typography/CopyableCellValue";
import { CohortStateField } from "generated-graphql/graphql";
import { startCase } from "lodash-es";
import { useMemo } from "react";

function toTitleCase(input: string): string {
  if (input.startsWith("is")) {
    return startCase(input.slice(2)) + "?";
  }

  return startCase(input);
}

export function CohortStateFields({ stateFields }: { stateFields: CohortStateField[] }) {
  const theme = useTheme();

  const columns = useMemo<GridColDef[]>(
    () => [
      {
        flex: 1,
        field: "key",
        valueGetter: (_, row) => toTitleCase(row.key),
        headerName: "Question",
      },
      {
        flex: 1,
        field: "value",
        headerName: "Answer",
        verticalAlign: "center",
        renderCell: (params) => {
          return (
            <CopyableCellValue
              params={params}
              text={params.row.value}
              variant="body2"
              sx={{ lineHeight: "inherit" }}
            />
          );
        },
      },
    ],
    []
  );

  return (
    <Box
      sx={{
        mt: 4,
        pt: 3,
        borderTop: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Typography variant="body2" sx={{ mb: 1.5, fontWeight: 500 }}>
        Facility State Fields
      </Typography>

      <Grid container spacing={3}>
        <DataGrid
          columns={columns}
          rows={stateFields}
          getRowId={(row) => row.key}
          isRowSelectable={() => false}
          pagination
          autoHeight
          initialState={{
            sorting: {
              sortModel: [
                {
                  field: "value",
                  sort: "desc",
                },
                { field: "key", sort: "asc" },
              ],
            },
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[10, 15, 50]}
          sx={{
            width: "100%",
            "& .MuiDataGrid-root": {
              width: "100%",
            },
            "& .MuiDataGrid-virtualScroller": {
              minHeight: "200px",
            },
            "& .MuiDataGrid-columnHeaders": {
              minHeight: "auto",
            },
            "& .MuiDataGrid-cell": {
              whiteSpace: "normal",
              wordWrap: "break-word",
            },
          }}
        />
      </Grid>
    </Box>
  );
}
